import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", { src: "/images/btn-facebook.png" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: "#",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.signIn()), ["prevent"])),
    class: "me-2"
  }, _hoisted_2))
}